import axios, { InternalAxiosRequestConfig } from "axios";
import { ACCESS_TOKEN } from "../constants/auth.ts";

const baseURL = import.meta.env.REACT_APP_BASE_URL;

export const server = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});
export const request = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

const requestConfiguration = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  if (config.url?.includes("auth")) {
    return config;
  }

  const token = localStorage.getItem(ACCESS_TOKEN);

  if (token) {
    config.headers.set("x-access-token", token);
  }

  return config;
};

const responseErrorHandler = (error: any) => {
  const errorMessage =
    error.response?.data?.message || error.message || "An error occurred";
  const token = localStorage.getItem(ACCESS_TOKEN);
  if (error.response?.status === 401 || !token) {
    localStorage.removeItem(ACCESS_TOKEN);
    window.location.href = `/auth${window.location.search}`;
  }
  return Promise.reject(error);
};

const responseSuccessHandler = (response: any) => {
  return response;
};

server.interceptors.request.use(requestConfiguration);
server.interceptors.response.use(responseSuccessHandler, responseErrorHandler);
